import { NgModule } from '@angular/core';

import { GroupByPipe } from './groupBy.pipe';
import { DateFormat } from './dateFormat.pipe';
import { DateTimeFormat } from './dateFormatTime.pipe';
import { TimeFormat } from './timeFormat.pipe';
import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { TruncatePipe } from './truncate.pipe';
import { SortByPipe } from './SortByPipe.pipe';
import { GroupByWithSumPipe } from './groupByWithSum.pipe';
import { SplitPipe } from './SplitPipe';
import { SortByDateTime } from './sortByTime';
import { NumberFormat } from './numberFormat';
import { SortByDateAndUndefinedPipe } from './sortbyDateAndUndefined.pipe';
import { CustomNumberPipe } from './numberCustom';
import { DistinctByPipe } from './distinctBy.pipe';
import { DragDirective } from 'src/app/layout/ffe/dragDropDirective';
import { ArrayLoopPipe } from './arrayloop';

@NgModule({
  declarations: [ArrayLoopPipe, DistinctByPipe ,SplitPipe , DragDirective, CustomNumberPipe, NumberFormat, GroupByWithSumPipe,SortByPipe, GroupByPipe, DateFormat, DateTimeFormat, TimeFormat,  SortByDateAndUndefinedPipe, FilterPipe,SearchPipe , TruncatePipe, SortByDateTime],
  imports: [],
  exports: [ArrayLoopPipe, DistinctByPipe, SplitPipe, CustomNumberPipe, DragDirective, GroupByWithSumPipe, NumberFormat,SortByPipe, GroupByPipe, DateFormat, DateTimeFormat, TimeFormat, SortByDateAndUndefinedPipe, FilterPipe,SearchPipe ,TruncatePipe, SortByDateTime]
})
export class PipesModule {}
